import { MenuItem, Box, Typography, Avatar, Select, SelectChangeEvent } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const languages = [
    { code: "en", label: "English", flagSrc: "./images/flags/us.svg" },
    { code: "da", label: "Dansk", flagSrc: "./images/flags/dk.svg" },
];

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleChange = (event: SelectChangeEvent) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <Select
      value={i18n.language}
      onChange={handleChange}
      size="small"
      sx={{ ml: 2, minWidth: 160, color: "white" }}
    >
      {languages.map((lang) => (
        <MenuItem color="inherit" key={lang.code} value={lang.code}>
          <Box display="flex" alignItems="center">
            <Avatar
              src={lang.flagSrc}
              alt={lang.label}
              sx={{ width: 20, height: 20, mr: 1 }}
              variant="square"
              imgProps={{ referrerPolicy: "no-referrer" }}
            />
            <Typography sx={{ color: "inherit" }} >{lang.label}</Typography>
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
};